/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsGet } from "../../funcs/llmModelsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetModelRequest$inboundSchema,
};

export const tool$llmModelsGet: ToolDefinition<typeof args> = {
  name: "llm-models-get",
  description: `Retrieve a model

Retrieves a model instance, providing basic information about the model such as the owner and supported capabilities.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
